import { GAS_STATION_MAX_GAS_AMOUNT } from "../constants";

/**
 * Resolve the `max_gas_amount` to submit with, given a transaction simulation.
 *
 * Applies a 2x buffer over the simulated cost with `defaultMaxGasAmount` as a
 * floor (simulation can under-report). On the gas-station path that same buffer
 * is also clamped to `GAS_STATION_MAX_GAS_AMOUNT`: the station rejects anything
 * larger, and unused gas is refunded, so clamping down costs nothing. Self-pay
 * transactions stay uncapped so a genuinely large transaction isn't starved
 * into OUT_OF_GAS.
 */
export function resolveMaxGasAmount(args: {
  simulatedMaxGas: number;
  defaultMaxGasAmount: number;
  useGasStation: boolean;
}): number {
  const buffered = Math.max(Math.ceil(args.simulatedMaxGas * 2), args.defaultMaxGasAmount);
  return args.useGasStation ? Math.min(buffered, GAS_STATION_MAX_GAS_AMOUNT) : buffered;
}
